__turbopack_context__.v({
  "close": "P31Gea_close",
  "container": "P31Gea_container",
  "content": "P31Gea_content",
  "control": "P31Gea_control",
  "dialog": "P31Gea_dialog",
  "icon": "P31Gea_icon",
  "image": "P31Gea_image",
  "youtube": "P31Gea_youtube",
});
